// =============================================================================
// TICKETS PAGES LAYOUTS
// =============================================================================

export default {
  path: '/ticketing',
    component: () => import('../../views/admin/tickets/index.vue'),
  children: [
    {
      path: 'support',
      component: () => import('../../views/admin/tickets/supportTicket/list/supportTicketChatList.vue'),
      children: [
        {
          path: '',
          name: 'supportTickets',
          component: () => import(/* webpackChunkName: "supportTickets" */ '../../views/admin/tickets/supportTicket/list/index'),
          meta: {
            permission: 'support_ticket.show',
            pageTitle: 'تیکت ها',
            pageTitleI18n: 'tickets.support.list.title',
            layoutStatus: 'chat'
            // rule: 'editor'
          }
        },
        {
          path: 'insert',
          name: 'insertSupportTicket',
          component: () => import(/* webpackChunkName: "insertSupportTicket" */ '../../views/admin/tickets/supportTicket/profile/supportTicketDetail.vue'),
          meta: {
            permission: 'support_ticket.create',
            pageTitle: 'افزودن تیکت جدید',
            pageTitleI18n: 'tickets.support.detail.title',
            layoutStatus: 'chat'
            // rule: 'editor'
          }
        },
        {
          path: ':id',
          name: 'supportTicketDetail',
          component: () => import(/* webpackChunkName: "supportTicketDetail" */ '../../views/admin/tickets/supportTicket/profile/supportTicketDetail.vue'),
          meta: {
            permission: 'support_ticket.show',
            pageTitle: '',
            pageTitleI18n: 'tickets.support.detail.title',
            layoutStatus: 'chat'
            // rule: 'editor'
          }
        }
      ]
    },
    {
      path: 'organizational',
      component: () => import('../../views/admin/tickets/organizationTicket/index.vue'),
      children: [
        {
          path: '/',
          name: 'organizationTickets',
          component: () => import(/* webpackChunkName: "organizationTickets" */ '../../views/admin/tickets/organizationTicket/list/ticketsOrganizationList.vue'),
          meta: {
            permission: 'organizational_ticket.show',
            pageTitle: 'تیکت ها',
            pageTitleI18n: 'tickets.organization.list.title'
            // rule: 'editor'
          }
        },
        {
          path: 'insert',
          name: 'insertOrganizationTicket',
          component: () => import(/* webpackChunkName: "insertOrganizationTicket" */ '../../views/admin/tickets/organizationTicket/insert/insertOrganizationTicket.vue'),
          meta: {
            permission: 'organizational_ticket.create',
            pageTitle: 'افزودن تیکت جدید',
            pageTitleI18n: 'tickets.organization.insert.title'
            // rule: 'editor'
          }
        },
        {
          path: ':id',
          name: 'organizationTicketDetail',
          component: () => import(/* webpackChunkName: "organizationTicketDetail" */ '../../views/admin/tickets/organizationTicket/profile/ticketOrganizationDetail.vue'),
          meta: {
            permission: 'organizational_ticket.show',
            pageTitle: '',
            pageTitleI18n: 'tickets.organization.detail.title'
            // rule: 'editor'
          }
        }
      ]
    }
  ]
}
